import { render, staticRenderFns } from "./costHelpSixtyTage.vue?vue&type=template&id=3b6b42ca&"
import script from "./costHelpSixtyTage.vue?vue&type=script&lang=js&"
export * from "./costHelpSixtyTage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b6b42ca')) {
      api.createRecord('3b6b42ca', component.options)
    } else {
      api.reload('3b6b42ca', component.options)
    }
    module.hot.accept("./costHelpSixtyTage.vue?vue&type=template&id=3b6b42ca&", function () {
      api.rerender('3b6b42ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2H3teQrewuxPk/JS/costHelpSixtyTage.vue"
export default component.exports